import { useState } from 'react';

import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { Menubar } from 'primereact/menubar';
import { Button } from 'primereact/button';
import { Tooltip } from 'primereact/tooltip';
import Dashboard from '../accounting/Dashboard';
import AccountsList from '../accounting/AccountsList';
import TransactionsList from '../accounting/TransactionsList';
import TransactionForm from '../accounting/TransactionForm';
export default function HoPage() {
	
	const [pageReady, setPageReady] = useState(true);
	// src/App.js
	return (
		<main id="HoPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
            </div>
            <div className="sm:col-12 comp-grid" >
                <div className="">
                    <div>
                        <Dashboard />
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
